<div class="flex flex-col items-center justify-center">
    <div class="w-full flex items-center justify-end">
        <button (click)="onDismiss()" class="w-6 h-6 rounded-md bg-gray-100">
            <i class="fas fa-times text-sm text-gray-500"></i>
        </button>
    </div>
    <p class="font-semibold font-display text-gray-700">Masukkan Password Baru</p>
    <form [formGroup]="form" (ngSubmit)="onConfirm()" class="mt-4 w-full font-display">
        <div class="col-span-2 relative">
            <input formControlName="password" type="password" [type]="showPass?'text':'password'" class="font-display h-11 px-4 bg-gray-100 rounded-md py-3 w-full mt-3 text-sm text-gray-500 focus:outline-none focus:ring-1 focus:ring-primary transition ease-out duration-300" placeholder="Masukkan Password Baru" [ngClass]="{ 'ring-1 ring-red-500' : form.get('password').hasError('minlength')}">
            <span (click)="toggle()" class="mr-3 absolute bottom-3 right-0 fa fa-fw fa-eye field-icon toggle-password cursor-pointer"></span>
        </div>
        <span *ngIf="form.get('password').hasError('minlength')" class="font-display text-xs text-red-500">
          Password minimal 6 karakter
        </span>
        <div class="flex w-full items-center justify-end mt-4">
            <button type="submit" class="px-3 py-2 text-white font-medium font-display text-sm bg-primary rounded-md">Simpan</button>
        </div>
    </form>
</div>
